export const accountUsername = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
